module.exports = __webpack_public_path__ + "static/crypto-accepted-382f26c9fc4da945546c9c8d0c8f54f9.png";